import { Button, ChipConfirmModal } from "@ondit/ui";
import { Trash2 } from "lucide-react";
import { useState } from "react";
import { useT } from "~/core/i18n";

/**
 * The bin, and the question it asks before it empties.
 *
 * The open state is this component's own because `ChipConfirmModal` is
 * controlled and has no trigger slot: a confirmation's dismiss paths — the
 * close mark, Escape, the overlay — all route through one `onOpenChange`, and
 * a trigger that opened it outside that handler would be a second path.
 */
export function ConfirmRemoval({
	label,
	onConfirm,
	disabled,
}: {
	label: string;
	onConfirm: () => void;
	disabled?: boolean;
}) {
	const t = useT();
	const [open, setOpen] = useState(false);
	return (
		<>
			<Button
				type="button"
				variant="ghost"
				size="icon"
				className="text-[var(--text-error)] hover-hover:text-[var(--text-error)]"
				aria-label={label}
				title={label}
				disabled={disabled}
				onClick={() => setOpen(true)}
			>
				<Trash2 aria-hidden />
			</Button>
			<ChipConfirmModal
				open={open}
				onOpenChange={setOpen}
				title={label}
				text={t("common.removeConfirm")}
				dismissLabel={t("common.cancel")}
				confirm={{
					label: t("common.remove"),
					variant: "destructive",
					disabled,
					onClick: () => {
						onConfirm();
						setOpen(false);
					},
				}}
			/>
		</>
	);
}
